import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Button, Input, Loader, Modal, Segment, SegmentGroup, Table } from "semantic-ui-react";
import { toast } from "../..";
import { createPaymentType } from "../../api/paymentTypes";
import { iniPaymentType, IPaymentType } from "../../models/paymentType";
import { fetchPaymentTypes } from "../../store/paymentTypesReducer";
import { PaymentTypeRow } from "./PaymentTypeRow";

interface Props {
    paymentTypes: IPaymentType[];
    paymentTypeCount: number;
}
export const PaymentTypeView = ({ paymentTypes, paymentTypeCount }: Props) => {
    const intl = useIntl();
    const [newPaymentType, setNewPaymentType] = useState<IPaymentType>(iniPaymentType);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleCreateNewPaymentTaype = async () => {
        try {
            setLoading(true);
            await createPaymentType(newPaymentType);
            toast(intl.formatMessage({ id: "paymentTypeCreted" }), true);
        } catch {
            toast(intl.formatMessage({ id: "unableToCreatePaymentType" }), false);
        } finally {
            setCreateModalOpen(false);
            fetchPaymentTypes(dispatch);
            setLoading(false);
        }
    };

    return (
        <div className="payment-table-container">
            <h1>{intl.formatMessage({ id: "paymentType" })}</h1>
            <SegmentGroup>
                <Segment className="container-for-buttons">
                    <Button
                        primary
                        onClick={() => setCreateModalOpen(true)}
                        content={intl.formatMessage({ id: "createPaymentType" })}
                    />
                </Segment>
                {loading ? (
                    <Loader active inline="centered" size="huge" />
                ) : (
                    <Segment>
                        <Table basic="very" compact="very">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Body>
                                    {paymentTypes.map((item, rowIndex) => (
                                        <PaymentTypeRow
                                            key={item.guid}
                                            paymentType={item}
                                            paymentTypeCount={paymentTypeCount}
                                            rowIndex={rowIndex}
                                        />
                                    ))}
                                </Table.Body>
                            </Table.Body>
                        </Table>
                    </Segment>
                )}
            </SegmentGroup>
            <Modal
                open={createModalOpen}
                closeIcon
                onClose={() => setCreateModalOpen(false)}
                dimmer="blurring"
                size="tiny"
            >
                <Modal.Content className="edit-modal">
                    <form className="add-user-form">
                        <section className="input-container">
                            <label>{intl.formatMessage({ id: "firstName" })}</label>
                            <Input
                                value={newPaymentType.name}
                                onChange={(e: any) =>
                                    setNewPaymentType({ ...newPaymentType, name: e.target.value })
                                }
                            />
                        </section>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={intl.formatMessage({ id: "paymentTypeEdit" })}
                        disabled={!newPaymentType.name}
                        primary
                        onClick={handleCreateNewPaymentTaype}
                        fluid
                    />
                </Modal.Actions>
            </Modal>
            </div>
    );
};
